import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TranslateService } from '../services/translation/translate.service';
import { ClientService } from '../services/client/client.service';
import { LanguageRegionMap } from 'src/app/types';

@Injectable({
  providedIn: 'root',
})
export class AuthEnabledGuard {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private clientService: ClientService
  ) {}

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree
  > {
    const lang = this.translate.language as LanguageRegionMap;
    if (!this.clientService.client?.isLoginEnabled) {
      this.router.navigateByUrl(`/${lang}/home`);
    }
    return true;
  }
}
